import { SearchProduct } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import ProductDetailSection from './ProductDetailSection';
import { useTranslations } from 'next-intl';

interface Props {
  product: SearchProduct;
}

function ProductDetailSectionDescription({ product }: Props) {
  const t = useTranslations('shop');

  if (!product.description) {
    return null;
  }

  return (
    <ProductDetailSection title={t('detail.description.title')}>
      <p className="text-base font-medium tracking-tight text-greyscale-body p-0 m-0">
        {product.description}
      </p>
    </ProductDetailSection>
  );
}

export default ProductDetailSectionDescription;
